import {useEffect} from 'react';
import {useInView} from 'react-intersection-observer';
import {ScrollableThemeKeywordTab} from '../../../../design-system/organisms/ScrollableThemeKeywordTab/ScrollableThemeKeywordTab';
import {TitleBar} from '../../../../design-system/organisms/TitleBar/TitleBar';
import {TitleBarType} from '../../../../design-system/organisms/TitleBar/TitleBarType.enum';
import {SchemeSection, ThemeSection} from '../../../../graphql/generated/types';
import {aggregateAndSendLog} from '../../../../logging/aggregateAndSendLog';
import {LOG_CLICK_EVENT} from '../../../../logging/logEvent';
import {putTiaraObjectProps} from '../../../../logging/putTiaraObjectProps';
import {CommonSectionProps} from '../../type';

export function Theme({section, children}: CommonSectionProps) {
  const {title, themeKeywordList} = section as Omit<ThemeSection, 'groups'>;
  const {ref, inView, entry} = useInView();

  useEffect(() => {
    if (inView && entry?.target) {
      aggregateAndSendLog({
        targetElem: entry.target as HTMLElement,
        actionType: 'ViewImp',
        actionName: '섹션_노출',
        customProps: {
          user_action: 'imp',
        },
      });
    }
  }, [entry, inView]);

  return (
    <div
      ref={ref}
      {...putTiaraObjectProps({
        click: {layer1: '테마', imp_id: 'stheme', imp_provider: 'service'},
        viewimp_contents: {
          layer1: '테마',
          imp_id: 'stheme',
          imp_provider: 'service',
          imp_type: 'vimp',
        },
        customProps: {
          section_type: '테마',
          section_title: title,
          landing_path: 'theme',
        },
        eventMeta: {
          id:
            'scheme' in section ? (section as SchemeSection).scheme : undefined,
          type: 'scheme',
          provider: '서비스',
        },
      })}
    >
      <TitleBar
        className="mb-4pxr"
        type={TitleBarType.Main}
        title={title || undefined}
        scheme={
          'scheme' in section ? (section as SchemeSection).scheme : undefined
        }
        onClickMore={e => LOG_CLICK_EVENT('더보기_클릭', e, undefined)}
      >
        {themeKeywordList && themeKeywordList.length !== 0 && (
          <ScrollableThemeKeywordTab
            itemList={themeKeywordList}
            onClickThemeTab={e => LOG_CLICK_EVENT('키워드_클릭', e, undefined)}
            {...putTiaraObjectProps({
              customProps: {content_cnt: String(themeKeywordList.length)},
            })}
          />
        )}
      </TitleBar>
      <div>{children}</div>
    </div>
  );
}
